import { CircleProgressBar, IProgressItemProps, ProgressItem, ProgressItemState } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import ENV from '../../base/env';
import { ProgressPageState } from './types';

export interface IProgressProps {
  page?: ProgressPageState;
  step?: number;
  max?: number;
  cfq?: boolean;
}

export const AssessmentProgress: React.FC<IProgressProps> = ({
  page = ProgressPageState.None,
  step = 1,
  max = 1,
  cfq = false,
}) => {
  const { t } = useTranslation();

  const introProps: IProgressItemProps = {
    name: 'intro',
    label: t('Progress.Trainingplan'),
  };
  const assessmentProps: IProgressItemProps = {
    name: 'assessment',
    label: t('Progress.Assessments'),
  };
  const evaluationProps: IProgressItemProps = {
    name: 'evaluation',
    label: t('Progress.Evaluation'),
  };
  const trainingplanProps: IProgressItemProps = {
    name: 'trainingplan',
    label: t('Progress.NewTrainingplan'),
  };
  const cfqQuestionaireProps: IProgressItemProps = {
    name: 'cfq',
    label: t('Progress.CFQ'),
  };

  const checkIconSrc = `${ENV.AssetsBaseUrl}/feature/exercise-icons/icon-checked.png`;

  switch (page) {
    case ProgressPageState.AssessmentSession:
      introProps.state = ProgressItemState.Done;
      introProps.iconSrc = checkIconSrc;
      assessmentProps.state = ProgressItemState.Active;
      assessmentProps.progress = step / max;
      assessmentProps.value = `${step}/${max}`;
      break;
    case ProgressPageState.CFQSession:
      introProps.state = ProgressItemState.Done;
      introProps.iconSrc = checkIconSrc;
      assessmentProps.state = ProgressItemState.Done;
      assessmentProps.iconSrc = checkIconSrc;
      cfqQuestionaireProps.state = ProgressItemState.Active;
      cfqQuestionaireProps.progress = step / max;
      cfqQuestionaireProps.value = `${step}/${max}`;
      break;
    case ProgressPageState.CFQSessionDone:
      introProps.state = ProgressItemState.Done;
      introProps.iconSrc = checkIconSrc;
      assessmentProps.state = ProgressItemState.Done;
      assessmentProps.iconSrc = checkIconSrc;
      cfqQuestionaireProps.state = ProgressItemState.Done;
      evaluationProps.state = ProgressItemState.Active;
      break;
    case ProgressPageState.EvaluationDone:
      introProps.state = ProgressItemState.Done;
      introProps.iconSrc = checkIconSrc;
      assessmentProps.state = ProgressItemState.Done;
      assessmentProps.iconSrc = checkIconSrc;
      cfqQuestionaireProps.state = ProgressItemState.Done;
      cfqQuestionaireProps.iconSrc = checkIconSrc;
      evaluationProps.state = ProgressItemState.Done;
      evaluationProps.iconSrc = checkIconSrc;
      break;
  }
  return (
    <CircleProgressBar>
      <ProgressItem {...introProps} />
      <ProgressItem {...assessmentProps} />
      {cfq ? <ProgressItem {...cfqQuestionaireProps} /> : null}
      <ProgressItem {...evaluationProps} />
      <ProgressItem {...trainingplanProps} />
    </CircleProgressBar>
  );
};

export default AssessmentProgress;
